import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { isIE11 } from 'src/app/shared/detect-ie11';

const IEWarningCookie = 'show_ie_warning';
const seenWarning = 'seen_warning';

@Component({
  selector: 'app-ie-warning',
  templateUrl: './ie-warning.component.html',
  styleUrls: ['./ie-warning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class IeWarningComponent implements OnInit {
  constructor(private changeDetector: ChangeDetectorRef) { }
  show = false;
  message = `For the full interactive 3D experience please try loading this content in Chrome or Firefox.`;

  ngOnInit() {

    // if we're not using IE, bail
    if (!isIE11()) {
      return;
    }

    // show the warning if the user hasn't dismissed it previously.
    const cookie = cookieExists(IEWarningCookie, seenWarning);


    // if cookie is true, do not show
    // if cookie is false, show
    this.show = !cookie;
    this.changeDetector.markForCheck();
  }

  handleDismissClick() {
    this.show = false;
    setCookie(IEWarningCookie, seenWarning);
  }
}

function setCookie(cookieName: string, cookieValue: string) {
  document.cookie = `${cookieName}=${cookieValue}`;
}

function cookieExists(cookieName: string, cookieValue: string) {
  return document.cookie.includes(`${cookieName}=${cookieValue}`);
}
